import { CallCenterIcon } from "./call-center-icon"
import { CodingIcon } from "./coding-icon"
import { MessageIcon } from "./message-icon"
import { PhoneIcon } from "./phone-icon"
import { VideoIcon } from "./video-icon"
import { WebIcon } from "./web-icon"

export { MessageIcon, PhoneIcon, WebIcon }
